import {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";

import { useFormik } from "formik";
import toast from "react-hot-toast";

import * as SVGImages from "../../svg";

import "../Asociados/createAsociados.css";
import "./createAbono.css";
import { createOrdenFormValidation } from "../../../../helper/validate";

import * as api from "helper/helper";
import "./../formsCommons.css";

import createOrdenStyles from "./createAbono.module.css";

import { EstadoBodega } from "../../../../helper/const";
import { buildNameWithId, Singleton } from "helper/tools";
import { PermissionsForSection } from "../auth";
import { Sections } from "../../data/navItem";
import { format, formatRelative } from "date-fns";

const ProrrateoModal = forwardRef(({ item, reloadOrdenes }, ref) => {
  const modalRef = useRef();
  const buttonCancelModalRef = useRef();
  const asociadoIdRef = useRef(0);

  /// CHECAR  useTraceUpdate(props, "CreateOrdenVenta");
  const [isActiveDisabled, setIsActiveDisabled] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [asociados, setAsociados] = useState([]);
  const [productos, setProductos] = useState([]);
  const [newItem, setNewItem] = useState(null);

  const [ordenSubtotal, setOrdenSubtotal] = useState(0);
  const [ordenDescuento, setOrdenDescuento] = useState(0);

  const [ordenTotal, setOrdenTotal] = useState(0);
  const [whole, setWhole] = useState([]);

  const [creditoSuperado, setCreditoSuperado] = useState(false);
  const [asociadoCongelado, setAsociadoCongelado] = useState(false);

  const [permissions, setPermissions] = useState({
    canCreate: true,
    canEdit: true,
    canVerDetalle: true,
  });

  const createMode = item == null || (item && Object.keys(item).length === 0);

  useEffect(() => {
    console.log("---> change item: " + item);
    let isActiveDisable = createMode;
    setIsActiveDisabled(isActiveDisable);

    setProductos([]);

    setOrdenDescuento([]);

    setOrdenSubtotal(0);
    setOrdenTotal(0);

    setNewItem(item);

    formik?.resetForm();

    loadItem(item);
    ///
    let awhole = [];
    if (item) {
      const cleanItems = item.map((r) => {
        const date1 = new Date(r.fecha);
        date1.setHours(0, 0, 0, 0);
        return {
          ...r,
          fechaClean: date1,
        };
      });
      const sortedItems = cleanItems.sort(
        (a, b) => b.fechaClean - a.fechaClean,
      );

      let lastDate = null;
      sortedItems.forEach((element) => {
        if (
          lastDate == null ||
          element.fechaClean.getTime() !== lastDate.getTime()
        ) {
          lastDate = element.fechaClean;

          const fechaInicial = format(lastDate, "dd-MMM-yyyy");
          awhole.push({ type: "section", name: fechaInicial });
          awhole.push(element);
        } else {
          awhole.push(element);
        }
      });
    }

    setWhole(awhole);

    //item.
  }, [item]);

  const fetchData = async () => {};

  useEffect(() => {
    formik?.resetForm();

    fetchData();

    const newPermissions = PermissionsForSection(Sections.Clientes);
    setPermissions(newPermissions);
  }, []);

  let initialValues = {
    id: 0,

    apartado: false,

    clienteId: null,
    asociadoId: 0,

    tipoEntregaId: 1,
    subTotalVenta: 0,
    descuento: 0,
    totalVenta: 0,
    ordenVentaDetalles: [],

    cantidad: 0,
  };

  const formik = useFormik({
    initialValues,
    enableReinitialize: true,
    validate: createOrdenFormValidation,
    validateOnBlur: false,
    validateOnChange: false,
    onSubmit: async (values, { props, setSubmitting }) => {
      if (values.clienteId === 0) values.clienteId = null;

      // normalize
      const ordenVentaDetalles = [].map((item) => {
        return {
          ordenVentaId: 0,
          productoId: item.id,
          cantidad: item.cantidad,
          precio: item.precio,
          total: item.total,
          subTotal: item.subTotal,
          descuento: item.descuento,
          promocionId: item.promocionId,
        };
      });

      values.totalVenta = ordenTotal;
      values.subTotalVenta = ordenSubtotal;

      values.ordenVentaDetalles = ordenVentaDetalles;

      /* default es En proceso Id = 1
      apartado = 2
      */
      const estadoBodegaId = formik.values.apartado
        ? EstadoBodega.Apartado
        : EstadoBodega.EnProceso;
      values.estadoBodegaId = estadoBodegaId;

      if (values.id === 0) {
        setIsLoading(true);
        const toastId = toast.loading("Creando Orden de Venta...");
        let response = await api.createOrdenVenta(values).catch((e) => {
          toast.dismiss(toastId);
          if (e.esError && e.codigoError && e.mensaje) {
            toast.error(`Error al Orden de Venta. ${e.mensaje}`);
            setIsLoading(false);
            return;
          }
          toast.error("Error al Orden de Venta.");
          setIsLoading(false);
        });

        setIsLoading(false);
        toast.dismiss(toastId);

        if (!response) return;

        toast.success("Orden de Venta creado.");
        reloadOrdenes();

        buttonCancelModalRef.current.click();
      } else {
        const toastId = toast.loading("Actualizando Orden...");
        setIsLoading(true);
        const response = await api.updateOrdenesVentas(values).catch((e) => {
          setIsLoading(false);
          toast.dismiss(toastId);
          toast.error("Error al actualizar Orden.");
        });
        if (!response) return;

        toast.dismiss(toastId);
        setIsLoading(false);

        toast.success("Orden actualizado.");
        reloadOrdenes();

        buttonCancelModalRef.current.click();
      }
    },
  });

  useImperativeHandle(ref, () => ({
    getValue: () => {
      return formik.values;
    },
    toggleModal: () => {
      formik?.resetForm();
      modalRef.current.click();
    },
  }));

  useEffect(() => {
    validateOrder();
  }, [ordenTotal]);

  const validateOrder = () => {
    validateAsociadoCredito();
    validateAsociadoCongelado();
  };

  const validateAsociadoCongelado = () => {
    if (asociadoIdRef.current === 0) {
      setAsociadoCongelado(false);
      return;
    }

    let asociado = asociados.find((item) => item.id === asociadoIdRef.current);

    if (asociado == null) {
      return;
    }
    setAsociadoCongelado(asociado.info?.congelado ?? false);
  };

  const validateAsociadoCredito = () => {
    if (asociadoIdRef.current === 0) {
      return;
    }

    let asociado = asociados.find((item) => item.id === asociadoIdRef.current);

    if (asociado == null) {
      return;
    }

    const creditoDisponible = asociado.info?.creditoDisponible;

    const superado = ordenTotal > creditoDisponible;
    setCreditoSuperado(superado);
  };

  function loadItem(newLoadItem) {
    const isEmpty = newLoadItem && Object.keys(newLoadItem).length === 0;
    if (isEmpty) {
      return;
    }

    if (newLoadItem == null) {
      return;
    }
  }

  function handleSubmit(event) {
    event.preventDefault();
  }

  console.log("--> CREATEORDEN Draw");
  const qtyTotal = item?.pagosCount ?? 0;
  /*
  const disponiblesText =
    formik.values.productSelected != null
      ? `Disponible ${formik.values.productSelected.option.cantidad}`
      : "Disponible - ";*/

  return (
    <>
      <button
        ref={modalRef}
        type="button"
        className="btn btn-primary"
        data-bs-toggle="modal"
        data-bs-target="#staticBackdropProrrateoModal"
        hidden
      >
        Abrir Crear Orden
      </button>

      <div
        className="modal fade  modal-sm"
        id="staticBackdropProrrateoModal"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabIndex="-1"
        aria-labelledby="staticBackdropProrrateoModalLabel"
        aria-hidden="true"
      >
        <div
          className="modal-dialog modal-dialog-scrollable"
          style={{ maxWidth: "500px" }}
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="staticBackdropLabel">
                Ver Prorrateos Aplicados
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>

            <div
              className="modal-body"
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <form className="row g-3" onSubmit={handleSubmit}>
                <div className="form-control" style={{ border: "none" }}>
                  {creditoSuperado && (
                    <div className="alert alert-danger" role="alert">
                      El total de la orden de venta <b>supera</b> el credito
                      para el asociado.
                    </div>
                  )}
                  {asociadoCongelado && (
                    <div className="alert alert-danger" role="alert">
                      No se puede realizar una Orden de Venta a un Asociado que
                      se encuentra en Estatus Congelado
                      <span>
                        <img
                          alt=""
                          src={SVGImages.SNOWFLAKE}
                          style={{
                            width: "16px",
                            height: "16px",
                            marginLeft: "5px",
                          }}
                        />
                      </span>
                    </div>
                  )}

                  <div className="mb-3">
                    <div className="row" style={{ fontSize: "15px" }}>
                      <p>Lista de pagos</p>
                    </div>
                    <div className="row">
                      <div className="container">
                        <ul className="list-group  table-fork">
                          {whole.map((pago, index) => {
                            if (pago.type) {
                              const pagoFecha = pago.name;

                              return (
                                <>
                                  <li
                                    className="list-group-item d-flex justify-content-between align-items-center"
                                    style={{
                                      paddingLeft: "5px",
                                      paddingRight: "5px",
                                    }}
                                  >
                                    <span
                                      className="badge text-bg-primary rounded-pill fs-6"
                                      style={{
                                        fontWeight: "bold",
                                        flex: "1",
                                      }}
                                    >
                                      {pagoFecha}
                                    </span>
                                  </li>
                                </>
                              );
                            }
                            /*  const pagoFecha = formatRelative(
                              pago.fecha,
                              new Date(),
                            );*/

                            const pagoFecha = format(pago.fecha, "hh:mm a");
                            const total = Singleton.getInstance().format(
                              pago.total,
                            );
                            return (
                              <>
                                <li
                                  className="list-group-item d-flex justify-content-between align-items-center text-bg-info"
                                  style={{
                                    paddingLeft: "16px",
                                    paddingRight: "16px",
                                  }}
                                >
                                  <span
                                    style={{
                                      fontWeight: "bold",
                                      flex: "1",
                                    }}
                                  >
                                    {pagoFecha}
                                  </span>
                                  <span className="badge text-bg-primary rounded-pill">
                                    {total}
                                  </span>

                                  <div
                                    className="DocSearch-Hit-action"
                                    style={{
                                      display: index > 1 ? "none" : "initial",
                                    }}
                                  >
                                    <button
                                      title="Deshacer Prorrateo"
                                      type="submit"
                                      className="DocSearch-Hit-action-button"
                                      onClick={async (e) => {
                                        let extraInfo = { id: pago.id };

                                        //TEMP
                                        //  const formaDePagoSelected = 1;
                                        /*  const porPagar = amountToSave();

                    if (parcialidadActual == null) {
                      console.log("--> INVALID parcialidadNumero");
                      return;
                    }
*/
                                        setIsLoading(true);

                                        const response = await api
                                          .undoProrrateo({
                                            id: pago.id,
                                          })
                                          .catch((e) => {
                                            toast.error(
                                              "Error al deshacer Prorrateo.",
                                            );
                                          });

                                        setIsLoading(false);
                                        if (!response) return;

                                        setTimeout(() => {
                                          reloadOrdenes?.();

                                          buttonCancelModalRef.current.click();
                                        }, 500);
                                      }}
                                    >
                                      <svg
                                        width="20"
                                        height="20"
                                        viewBox="0 0 20 20"
                                      >
                                        <g
                                          stroke="currentColor"
                                          fill="none"
                                          fill-rule="evenodd"
                                          stroke-linecap="round"
                                          stroke-linejoin="round"
                                        >
                                          <path d="M3.18 6.6a8.23 8.23 0 1112.93 9.94h0a8.23 8.23 0 01-11.63 0"></path>
                                          <path d="M6.44 7.25H2.55V3.36M10.45 6v5.6M10.45 11.6L13 13"></path>
                                        </g>
                                      </svg>
                                    </button>
                                  </div>

                                  {/*<div className="DocSearch-Hit-action">
                                    <button
                                      title="Remove this search from history"
                                      type="submit"
                                      className="DocSearch-Hit-action-button"
                                    >
                                      <svg
                                        width="20"
                                        height="20"
                                        viewBox="0 0 20 20"
                                      >
                                        <path
                                          d="M10 10l5.09-5.09L10 10l5.09 5.09L10 10zm0 0L4.91 4.91 10 10l-5.09 5.09L10 10z"
                                          stroke="currentColor"
                                          fill="none"
                                          fill-rule="evenodd"
                                          stroke-linecap="round"
                                          stroke-linejoin="round"
                                        ></path>
                                      </svg>
                                    </button>
                                  </div>*/}
                                </li>

                                {pago?.subPagos?.map((subPago, index) => {
                                  const nombre =
                                    subPago?.parcialidad?.productoParcialidad
                                      ?.ordenVentaDetalle?.producto?.nombre ??
                                    `Interes ${index + 1}`;
                                  const total = Singleton.getInstance().format(
                                    subPago.total,
                                  );
                                  return (
                                    <>
                                      <li
                                        className="list-group-item d-flex justify-content-between align-items-center table-fork"
                                        style={{
                                          paddingLeft: "16px",
                                          paddingRight: "16px",
                                        }}
                                      >
                                        <span>{nombre}</span>
                                        <span className="badge text-bg-info rounded-pill">
                                          {total}
                                        </span>
                                      </li>
                                    </>
                                  );
                                })}
                              </>
                            );
                          })}
                        </ul>

                        <div className="valid-feedback"></div>
                        <div className="invalid-feedback">
                          {formik.errors.productosCantidad}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-primary"
                    data-bs-dismiss="modal"
                    ref={buttonCancelModalRef}
                  >
                    Cerrar
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
});

export default ProrrateoModal;
